import { Component, Input, type OnInit } from '@angular/core'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'

export function createMultiUnitSettingsForm(fb: FormBuilder) {
  return fb.group({
    auto_assign: ['created'],
    days: [0, [Validators.min(0)]],
    auto_compact: [false],
  })
}

@Component({
  selector: 'app-multi-unit-reservation-settings',
  templateUrl: './multi-unit-reservation-settings.component.html',
  styles: [
    `
      :host {
        display: block;
      }
    `,
  ],
})
export class MultiUnitReservationSettingsComponent implements OnInit {
  @Input() form: FormGroup
  constructor() {}

  ngOnInit(): void {}
}
